"use client"
import React, { useState, useRef, useEffect } from 'react';
import Link from 'next/link';

import { Button } from 'primereact/button';
import { useInterval } from 'primereact/hooks';
import { classNames } from 'primereact/utils';
import { Toast } from 'primereact/toast';

import AuthStorage from './storage/AuthStorage';
import AuthController from './controller/AuthController';

export const AppFooter = (props) => {

    const MaxSeconds = 2400;


    const [authStorage, setAuthStorage] = useState(undefined);

    const [active, setActive] = useState(true);
    const [idleSeconds, setIdleSeconds] = useState(0);
    const toast = useRef();
    const [version, setVersion] = useState(process.env.NEXT_PUBLIC_VERSION);

    useEffect(() => {

        const newAuthStorage = new AuthStorage(window.location.pathname.toLowerCase());
        setIdleSeconds(Number(newAuthStorage.getIdleTime()));
        setAuthStorage(newAuthStorage);

    }, []);

    function padTo2Digits(num) {
        return num.toString().padStart(2, '0');
    }

    function printSecondsToTime(totalSeconds) {

        let minutes = Math.floor(totalSeconds / 60);
        let seconds = totalSeconds % 60;
        return `${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`;
    }

    useInterval(
        () => {

            let segundosGracia = 5;
            let newIdleSeconds = Number(authStorage.getIdleTime());
            newIdleSeconds++;

            if (newIdleSeconds === MaxSeconds) {
                toast.current.show({ severity: "warn", summary: "Sesión a expirar", detail: "Su sesión va a expirar por inactividad", life: segundosGracia * 1000 });
            }
            else if (newIdleSeconds > MaxSeconds + segundosGracia) {
                logout();
            }

            authStorage.setIdleTime(newIdleSeconds);
            setIdleSeconds(newIdleSeconds);

        },
        1000,
        active
    );

    const logout = () => {
        const authController = new AuthController();
        authController.logout();
        window.location.href = process.env.NEXT_PUBLIC_FOLDER_APP + "/";
    }

    return (
        <>
            <Toast ref={toast} position="center" />
            <div className="layout-footer" >
                <img src={props.layoutColorMode === 'light' ? '../assets/layout/images/logo-dark-footer.png' : '../assets/layout/images/logo-white.svg'} alt="Logo" height="20" className="mr-2" />

                <div style={{ fontSize: "10px" }}>
                    by
                    <span className="font-medium ml-2">TICSOFT® - PRISMAU (
                        <Link target="_blank" rel="noopener noreferrer" href="https://ticsoft.co">ticsoft.co</Link>
                        )</span>
                    <span className="">Versión:&nbsp;{version}</span>
                    <br></br>
                    <span className="">&nbsp;Inactividad&nbsp;</span>
                    <span className="font-bold">{printSecondsToTime(idleSeconds)}&nbsp;</span>
                    <span className="">{" / " + printSecondsToTime(MaxSeconds)}</span>

                </div>

            </div>
        </>);
    //<div></div> <span className="font-medium ml-2">esta parte va a ser la sección de información de sessión.</span>

}
